import { useState } from "react";
import { makeStyles } from "@mui/styles";
import { AppBar, Toolbar, Typography, Button } from "@mui/material";
import { useHistory } from "react-router-dom";
import { generateGtmEvent } from "../../../Helpers";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 72,
    boxSizing: "border-box",
    paddingLeft: 32,
    paddingRight: 32,
    maxWidth: "1280px",
    width: "100%",
    // [theme.breakpoints.up("lg")]: {
    //   paddingLeft: 86,
    //   paddingRight: 86,
    // },
    [theme.breakpoints.down("md")]: {
      paddingLeft: 12,
      paddingRight: 12,
    },
  },
  logo: {
    color: theme.palette.text.primary,
    fontSize: 24,
    fontWeight: 700,
    letterSpacing: 0.18,
    marginRight: 48,
  },
  mainContentLink: {
    paddingLeft: 16,
    paddingRight: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0,
    height: "100%",
    textDecoration: "none",
    "&:focus": {
      opacity: 1,
      background: "white",
      outlineColor: "#1A237E",
    },
  },
  mainContentLinkText: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    fontSize: "1.125em",
  },
}));

interface LoginHeaderProps {
  showLogin?: boolean;
  showDemo?: boolean;
}

export const LoginHeader = (props: LoginHeaderProps) => {
  const classes = useStyles();
  const history = useHistory();
  const [isFocused, setIsFocused] = useState(false);

  const HandleFocus = () => {
    setIsFocused(true);
  };
  const HandleDataLayer = (
    event: string,
    action: string,
    name: string,
    type: string,
    region: string,
    section: string,
    text: string
  ) => {
    generateGtmEvent({ event, action, name, type, region, section, text });
  };

  return (
    <AppBar
      sx={{
        alignItems: "center",
        borderBottom: `2px solid #dedede`,
        boxSizing: "border-box",
        height: "72px",
      }}
      position="static">
      <Toolbar disableGutters className={classes.root} tabIndex={-1}>
        {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
        <Typography
          variant="h4"
          component="h1"
          noWrap
          sx={{
            display: { sm: "flex" },
            cursor: "pointer",
            overflow: "visible",
          }}
          onClick={() => {
            HandleDataLayer(
              "link",
              "click",
              "onclick",
              "internal link",
              "navbar",
              "main navbar",
              "Digit logo"
            );
            window.location.href = "https://digit.asu.edu/";
          }}
          className={classes.logo}>
          Digit
        </Typography>
        <a
          tabIndex={0}
          onFocus={HandleFocus}
          href="#main"
          className={classes.mainContentLink}
          style={{
            opacity: isFocused ? 1 : 0,
            top: isFocused ? "1.5rem" : "-10rem",
            position: isFocused ? "static" : "absolute",
          }}>
          <Typography
            variant="h4"
            component={"p"}
            className={classes.mainContentLinkText}>
            Skip to main content
          </Typography>
        </a>
        {props.showLogin ? (
          <>
            (
            <Button
              onClick={() => {
                HandleDataLayer(
                  "modal",
                  "open",
                  "onclick",
                  "click",
                  "navbar",
                  "main navbar",
                  "Log in"
                );
                history.push("/");
              }}
              variant="contained"
              color="primary"
              size="large"
              sx={{
                marginLeft: "auto",
                height: "48px",
                borderRadius: "8px",
              }}>
              Log in
            </Button>
            )
          </>
        ) : (
          props.showDemo && <></>
        )}
      </Toolbar>
    </AppBar>
  );
};
